import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  Renderer2,
  HostListener,
  OnInit,
  AfterViewInit,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-hero-banner',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './hero-banner.component.html',
  styleUrl: './hero-banner.component.scss',
})
export class HeroBannerComponent implements AfterViewInit {
  @Input() title: string = '';
  @Input() isFullBanner: boolean = false;
  @Input() imgPath: string = '';

  constructor(private renderer: Renderer2) {}

  navOpen = false;
  isScrolled = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const offset = window.scrollY;
    // const heroHeight =
    //   document.querySelector('.hero-banner')?.clientHeight || 0;
    const heroHeight = window.innerHeight / 2;

    if (offset > heroHeight) {
      this.isScrolled = true;
      setTimeout(
        () => document.querySelector('.header')?.classList.add('visible'),
        10
      );
    } else {
      this.isScrolled = false;
      document.querySelector('.header')?.classList.remove('visible');
    }
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  toggleNav() {
    this.navOpen = !this.navOpen;
    if (this.navOpen) {
      this.renderer.addClass(document.body, 'no-scroll');
    } else {
      this.renderer.removeClass(document.body, 'no-scroll');
    }
  }
}
